var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "rating-scale-settings" } }, [
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "field-label" } },
        [_vm._v(_vm._s(_vm.$t("form.fieldLabel")))]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.ratingScale.fieldLabel,
            expression: "item.ratingScale.fieldLabel",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "text", id: "field-label" },
        domProps: { value: _vm.item.ratingScale.fieldLabel },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.item.ratingScale, "fieldLabel", $event.target.value)
            },
            function ($event) {
              return _vm.setFieldLabel(_vm.item.ratingScale.fieldLabel)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.labelAlignment"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "button-group" }, [
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "left" },
            on: {
              click: function ($event) {
                return _vm.setAlignment("left")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.left")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "right" },
            on: {
              click: function ($event) {
                return _vm.setAlignment("right")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.right")) + "\n                ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "top" },
            on: {
              click: function ($event) {
                return _vm.setAlignment("top")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.top")))]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.chooseLabelAlignment"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [_vm._v("Görünürlük")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "toggle", on: { click: _vm.toggleVisibility } },
        [
          _c(
            "span",
            { staticClass: "toggle-option", class: { active: _vm.visibility } },
            [_vm._v(_vm._s(_vm.visibility ? "Görünür" : "Gizli"))]
          ),
        ]
      ),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("Bu alanın form üzerinde görünür olup olmayacağını belirler"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label", attrs: { for: "slug-input" } }, [
        _vm._v("URL Parametresi"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.slug,
            expression: "slug",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "text", id: "slug-input", placeholder: "ratingScale" },
        domProps: { value: _vm.slug },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.slug = $event.target.value
            },
            function ($event) {
              return _vm.setSlug($event.target.value)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v("URL parametrelerinde kullanılacak benzersiz tanımlayıcı"),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.subLabel1"))),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.ratingScale.subLabelOne,
            expression: "item.ratingScale.subLabelOne",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "text" },
        domProps: { value: _vm.item.ratingScale.subLabelOne },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.item.ratingScale, "subLabelOne", $event.target.value)
            },
            function ($event) {
              return _vm.setSubLabelOne(_vm.item.ratingScale.subLabelOne)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.subLabel2"))),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.ratingScale.subLabelTwo,
            expression: "item.ratingScale.subLabelTwo",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "text" },
        domProps: { value: _vm.item.ratingScale.subLabelTwo },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.item.ratingScale, "subLabelTwo", $event.target.value)
            },
            function ($event) {
              return _vm.setSubLabelTwo(_vm.item.ratingScale.subLabelTwo)
            },
          ],
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }